import commonApi from './CommonApi.js';

export default {
	getInfo: async (parameters) => {
		return await commonApi().get('/v1/alertPreference/getInfo', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	edit: async (viewModel) => {
		return await commonApi().put('/v1/alertPreference?language=' + window.currentLanguageEnum, viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	}
}